module.exports = __webpack_public_path__ + "static/teleco_17-8b97f5ed5301f8c80da19effd3935d67.jpg";